import { render, staticRenderFns } from "./AuthorizeModal.vue?vue&type=template&id=335c277e&"
import script from "./AuthorizeModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports